const SUBSCRIPTION_URL = "https://umlang.com/Subscription";

export function decodeToken(token) {
  if (!token) return null;
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch {
    return null;
  }
}

export function getUserTypesFromToken() {
  const token = localStorage.getItem("token");
  const payload = decodeToken(token);
  return payload?.type || [];
}

export function hasPremiumAccess(userTypes) {
  return userTypes.some((t) =>
    ["userPremium", "freetrial_all"].includes(t)
  );
}

export function requirePremium(message) {
  const types = getUserTypesFromToken();
  if (!hasPremiumAccess(types)) {
    window.location.href = SUBSCRIPTION_URL;
    return false;
  }
  return true;
}

export function redirectToSubscription() {
  window.location.href = SUBSCRIPTION_URL;
}

export { SUBSCRIPTION_URL };
